import Vue from 'vue';
import AccountModal from '@components/accountModal/AccountModal';
import { i18n, store } from '@/main';

// vue-router runs in-component guards only on the component registered on the
// route record — this wrapper, not the wrapped component. Forward them, bound
// to the wrapped INSTANCE ($children[0]): its iframe listeners share state
// with the guard (e.g. ReactDashboard's isEditModeGuardDirty / reactRoute).
const forwardRouteGuard = (component, hook) =>
    function (to, from, next) {
        const guard = component[hook];
        if (!guard) {
            next();
            return;
        }
        guard.call(this.$children[0] || this, to, from, next);
    };

const WithAccountModal = (component) =>
    Vue.component('WithAccountModal', {
        props: {
            ...component.props,
        },
        listeners: {
            ...component.listeners,
        },
        beforeRouteUpdate: forwardRouteGuard(component, 'beforeRouteUpdate'),
        beforeRouteLeave: forwardRouteGuard(component, 'beforeRouteLeave'),
        render(createElement) {
            return createElement(component, {
                props: {
                    ...this.$props,
                },
                on: {
                    ...this.$listeners,
                    showAccountModal: this.showAccountModal,
                },
            });
        },
        methods: {
            // Opens AccountModal for editing or deleting a workspace. Creating one
            // from here was removed with the Plan A sign-up block (TASK-14124):
            // AccountModal saves edits itself and only emits `confirm` on create.
            showAccountModal(data) {
                const body = document.body;

                let instance;
                const modal = Vue.extend(AccountModal);

                const destroyInstance = () => {
                    instance.$destroy(true);
                    body.removeChild(instance.$el);
                };
                instance = new modal({
                    propsData: {
                        active: true,
                        ...data,
                    },
                    i18n,
                    store,
                });
                instance.$on('update:active', (value) => {
                    if (!value) {
                        destroyInstance();
                    }
                });
                instance.$mount();
                body.appendChild(instance.$el);
            },
        },
    });

export default WithAccountModal;
